import { useEffect, useState } from "react";
import { Files, MagnifyingGlass } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { PageHeader, SectionTitle } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import ReportDocSlots from "@/components/ReportDocSlots";

export default function StatutoryReports() {
  const [jobs, setJobs] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);

  useEffect(() => {
    api.get("/jobs")
      .then(({ data }) => setJobs(Array.isArray(data) ? data : (data?.jobs || [])))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, []);

  const filtered = jobs.filter((j) => {
    const s = `${j.reference || ""} ${j.applicant_name || ""} ${j.bank_name || ""}`.toLowerCase();
    return s.includes(q.toLowerCase());
  }).slice(0, 80);

  return (
    <div className="space-y-6 max-w-3xl" data-testid="statutory-reports-page">
      <PageHeader overline="02 · Valuation Data" title="Statutory Reports" subtitle="Upload, track and share each job's statutory documents — independent of the valuation report" />

      <Card className="p-5 border-border">
        <SectionTitle icon={Files}>Select a job</SectionTitle>
        <div className="relative mt-1">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input placeholder="Search by reference, applicant or bank…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="statutory-job-search" />
        </div>
        <div className="max-h-64 overflow-auto divide-y divide-border rounded-lg border border-border mt-3" data-testid="statutory-job-list">
          {filtered.length === 0 && <p className="text-sm text-muted-foreground p-3">No jobs found.</p>}
          {filtered.map((j) => (
            <button type="button" key={j.id} onClick={() => setSel(j)}
              className={`w-full text-left px-3 py-2 transition-colors hover:bg-muted ${sel?.id === j.id ? "bg-muted" : ""}`}
              data-testid={`statutory-job-${j.id}`}>
              <div className="text-sm font-medium text-primary truncate">{j.reference || "—"} · {j.applicant_name || "Unnamed"}</div>
              <div className="text-xs text-muted-foreground truncate">{j.bank_name || ""}{j.property_address ? ` · ${j.property_address}` : ""}</div>
            </button>
          ))}
        </div>
      </Card>

      {sel && (
        <Card className="p-5 border-border" data-testid="statutory-selected-job">
          <div className="text-sm font-semibold text-primary mb-1">{sel.reference} · {sel.applicant_name}</div>
          <ReportDocSlots jobId={sel.id} />
        </Card>
      )}
    </div>
  );
}
